// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Clik","location":"Header_location__1rwzQ"};